import Breadcrumb from '../../layout/breadcrumb';
import React, { useState, useEffect, Fragment, useCallback, useRef } from 'react';
import Rating from 'react-rating';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, Tooltip } from 'reactstrap';
import { useGlobalState } from 'state-pool';
import SweetAlert from 'sweetalert2';

import { spaceship_firstName, spaceship_lastName } from '../../constant/names';

import ReactPaginate from 'react-paginate';
import { ASSETS_CDN } from '../../constant/config';
import { useStore } from '../../store/main.store';
import shallow from 'zustand/shallow';

import { Loading } from '../Loading';
import { Information } from '../utils/Information';
import { Filter } from '../Filter';

import CONTRACT_LIST from '../../contracts/contractList';

import Moment from 'react-moment';

const MARKETPLACE_CONTRACT = CONTRACT_LIST['MARKETPLACE_CONTRACT'];

const MarketplaceSpaceships = () => {
  const [web3, setWeb3] = useGlobalState('Web3');
  const [videoAnimation] = useGlobalState('animateVideo');
  const [userAddress, setUserAddress] = useGlobalState('userAddress');
  const [spaceshipContract, setSpaceshipContract] = useGlobalState('spaceshipContract');
  const [marketplaceContract, setMarketplaceContract] = useGlobalState('marketplaceContract');
  const [cryptominesContract, setCryptominesContract] = useGlobalState('cryptominesContract');
  const [stoneContract, setStoneContract] = useGlobalState('stoneContract');

  const [spaceshipAmount, setSpaceshipAmount] = useGlobalState('spaceshipAmount');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');
  const [maxWorkers, setMaxWorkers] = useGlobalState('maxWorkers');

  // Local state
  const [layoutColumns, setLayoutColumns] = useState(3);
  const [pageNumber, setPageNumber] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filtering, setFiltering] = useState(false);

  const ARRAY_TO_FILTER = useRef();

  const { marketSpaceships, updateMarketSpaceships, displayDataShips, updateDisplayDataShips } = useStore(
    (state) => ({
      marketSpaceships: state.marketSpaceships,
      displayDataShips: state.displayDataShips,
      updateMarketSpaceships: state.updateMarketSpaceships,
      updateDisplayDataShips: state.updateDisplayDataShips,
    }),
    shallow
  );

  const cardsPerPage = 8;
  const pageCount = Math.ceil(marketSpaceships?.length / cardsPerPage);

  const getMetadata = async (sp) => {
    if (web3 === undefined || marketplaceContract === null) return;
    const spaceship = Object.assign({ id: sp.tokenId }, sp);
    if (spaceship.nftData['firstName'] >= 0 && spaceship.nftData['firstName'] <= 60) {
      spaceship['variant'] = 1;
    } else if (spaceship.nftData['firstName'] >= 61 && spaceship.nftData['firstName'] <= 90) {
      spaceship['variant'] = 2;
    } else {
      spaceship['variant'] = 3;
    }
    spaceship['uid'] =
      spaceship['id'] + spaceship.nftData['roll'] + spaceship.nftData['firstName'] + spaceship.nftData['lastName'];
    spaceship['price'] = web3.utils.fromWei(sp.price, 'ether');
    spaceship['sellerAddress'] = sp.sellerAddress;

    spaceship['marketId'] = sp.marketId;
    spaceship['seller'] = sp.sellerAddress.slice(38, 42);

    const nftInfo = await marketplaceContract.methods.getMarketItem(sp.marketId).call({ from: userAddress });

    if (nftInfo.buyerAddress !== '0x0000000000000000000000000000000000000000') {
      spaceship['sold'] = 1;
    } else {
      spaceship['sold'] = 0;
    }

    const TRANSFER_TIME = 0;
    const transferCooldown = await spaceshipContract.methods.getTokenCooldown(sp.tokenId).call({ from: userAddress });
    //console.log(transferCooldown)
    let now = parseInt((Date.now() / 1000).toFixed(0));
    if (transferCooldown > now - TRANSFER_TIME) {
      spaceship['canTransfer'] = 0;
    } else {
      spaceship['canTransfer'] = 1;
    }
    spaceship['transferCooldown'] = (parseInt(transferCooldown) + 0) * 1000;

    return spaceship;
  };

  const fetchSpaceships = useCallback(async () => {
    setLoading(true);
    try {
      fetch('https://api.cryptomines.app/api/spaceships')
        .then((response) => response.json())
        .then((jsonData) => jsonData)
        .then((marketNft) => {
          updateMarketSpaceships(
            marketNft.sort((a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether'))
          );
          ARRAY_TO_FILTER.current = marketNft.sort(
            (a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether')
          );
        })
        .catch((error) => {
          // handle your errors here
        });

      // const ___data = require('../../marketItems.json');
      // updateMarketSpaceships(___data);
      // ARRAY_TO_FILTER.current = ___data;

      if (marketplaceContract !== null) {
        const stoneAllowanceMarket = await stoneContract.methods
          .allowance(userAddress, MARKETPLACE_CONTRACT)
          .call({ from: userAddress });

        if (stoneAllowanceMarket < 1) {
          SweetAlert.fire({
            title: 'Approve Marketplace Contract',
            html: 'You need to approve your <b>$ETERNAL</b> token on the <b>Marketplace Contract.</b>',
            icon: 'info',
            confirmButtonText: 'Approve Contract',
            reverseButtons: true,
          }).then(async (result) => {
            await stoneContract.methods
              .approve(MARKETPLACE_CONTRACT, web3.utils.toWei('5000000', 'ether'))
              .send({ from: userAddress });
          });
        }
      }
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketplaceContract, userAddress]);

  // First page render
  useEffect(() => {
    if (web3 !== null && marketplaceContract !== null && userAddress !== null) {
      fetchSpaceships().then((data) => {
        // rerenderList();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketplaceContract, web3, userAddress, fetchSpaceships]);

  useEffect(() => {
    rerenderList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtering, marketSpaceships]);

  const rerenderList = () => {
    if (filtering) {
      updateDisplayDataShips(
        marketSpaceships.sort((a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether'))
      );
      updateDisplayDataShips(
        marketSpaceships
          .sort((a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether'))
          .slice(0, cardsPerPage)
      );
      setLoading(false);
    } else {
      setLoading(true);
      fetch(`https://api.cryptomines.app/api/spaceships?cursor=${pageNumber}&limit=${cardsPerPage}`)
        .then((response) => response.json())
        .then((jsonData) => jsonData)
        .then((nftItems) => {
          updateDisplayDataShips(nftItems);
          setLoading(false);
        })
        .catch((error) => {
          // handle your errors here
          console.error(error);
        });
    }
  };

  // const foo = pageNumber * cardsPerPage;
  const changePage = async ({ selected }) => {
    setLoading(true);
    setPageNumber(selected);
    const offset = selected * cardsPerPage;

    if (filtering) {
      updateDisplayDataShips(marketSpaceships);
      updateDisplayDataShips(marketSpaceships.slice(offset, offset + cardsPerPage));
      setLoading(false);
    } else {
      fetch(`https://api.cryptomines.app/api/spaceships?cursor=${offset}&limit=${cardsPerPage}`)
        .then((response) => response.json())
        .then((jsonData) => jsonData)
        .then((d) => {
          updateDisplayDataShips(
            d.sort((a, b) => web3.utils.fromWei(a.price, 'ether') - web3.utils.fromWei(b.price, 'ether'))
          );
          setLoading(false);
        })
        .catch((error) => {
          // handle your errors here
          console.error(error);
        });
    }
  };

  const buySpaceship = async (marketId) => {
    window.gtag('event', 'buyNFT', { marketId: marketId, address: userAddress });
    SweetAlert.fire({
      title: 'You want to <b>BUY</b> this NFT? ',
      icon: 'question',
      confirmButtonText: 'Proceed',
      footer:
        '<center><span class="txt-danger">Please double check the amount of ETERNAL. <br>You can\'t recover ETERNAL. <br><b>We neither.</b></span></center>',
    }).then(async () => {
      const buyingShip = await marketplaceContract.methods.buyNFT(marketId).send({ from: userAddress });
      //
      await fetchSpaceships().then(setLoading(false));
      const currentStones = await stoneContract.methods.balanceOf(userAddress).call({ from: userAddress });
      const currentSpaceships = await spaceshipContract.methods.balanceOf(userAddress).call({ from: userAddress });
      const currentMaxWorkers = await cryptominesContract.methods.getMaxWorkers().call({ from: userAddress }); //workers
      setSpaceshipAmount(currentSpaceships);
      setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));
      setMaxWorkers(currentMaxWorkers);
      SweetAlert.fire({
        title: 'Nice!',
        text: 'Your NFT was purchased. 😊 ',
        icon: 'success',
      });
    });
  };

  const unlistNFT = async (marketId) => {
    window.gtag('event', 'unlistNFT', { marketId: marketId, address: userAddress });
    await marketplaceContract.methods.unlistNFT(marketId).send({ from: userAddress });
    SweetAlert.fire({
      title: 'Nice!',
      text: 'Your NFT was unlisted. 😊 ',
      icon: 'success',
    });
  };

  const showOnly = displayDataShips?.map((card, i) => (
    <SpaceshipCard
      key={card.marketId}
      card={card}
      layoutColumns={layoutColumns}
      videoAnimation={videoAnimation}
      buySpaceship={buySpaceship}
      unlistNFT={unlistNFT}
      userAddress={userAddress}
      getMetadata={getMetadata}
    />
  ));

  return (
    <Fragment>
      <Breadcrumb parent='Marketplace' title='Marketplace' />
      <Container fluid={true}>
        <Row>
          <Col sm='12'>
            <Card className='card-absolute'>
              <CardHeader className='bg-secondary'>
                <h3>Marketplace - Spaceships </h3>
                {/* <button
                  className='toggle-information btn btn-success'
                  onClick={() => setToggleInformation(!toggleInformation)}
                >
                  ?
                </button> */}
              </CardHeader>
              <CardBody>
                <Information section='marketSpacehips' display={true} />
                <div style={{ position: 'relative' }}>
                  <Filter
                    stateRef={ARRAY_TO_FILTER.current}
                    marketSpaceships={marketSpaceships}
                    updateMarketSpaceships={updateMarketSpaceships}
                    setFiltering={setFiltering}
                    wallet={userAddress}
                    web3={web3}
                  />
                </div>
                {loading ? <Loading /> : ''}
                {marketSpaceships?.length && marketSpaceships?.length > cardsPerPage ? (
                  <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    pageCount={pageCount}
                    onPageChange={changePage}
                    containerClassName={'pagination'}
                    previousLinkClassName={'previousBttn'}
                    nextLinkClassName={'nextBttn'}
                    disabledClassName={'paginationDisabled'}
                    activeClassName={'activeLinkClassName'}
                    pageClassName='page-item'
                  />
                ) : (
                  ''
                )}

                <Row className='gridRow'>{displayDataShips?.length > 0 && !loading ? <>{showOnly}</> : ''}</Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

const SpaceshipCard = ({ card, videoAnimation, buySpaceship, unlistNFT, userAddress, layoutColumns, getMetadata }) => {
  const [convert, setConvert] = useState(undefined);
  const [btnTooltip, setBtnTooltip] = useState(false);
  const toggle = () => setBtnTooltip(!btnTooltip);

  useEffect(() => {
    getMetadata(card).then((d) => setConvert(d));
  }, [card, getMetadata]);

  return convert !== undefined ? (
    <div
      className={`${layoutColumns === 3 ? 'col-xl-3 col-sm-6 xl-4 col-grid-box' : 'col-xl-' + layoutColumns}`}
      key={card.tokenId}
    >
      <Card>
        <div className={`product-box ${convert.sold === 0 ? '' : 'disabled'}`}>
          <span className='ribbon ribbon'>
            <b>UID: </b> 0x{convert.uid}
            <br />
            <b>Market ID: </b> 0x{convert.marketId}
            <br />
            <b>Seller: </b> 0x...{convert.seller}
            <br />
            <b>Name: </b> {spaceship_firstName[card.nftData.firstName]} {spaceship_lastName[card.nftData.lastName]}
            <br />
            <b>Transfer Cooldown: </b>{' '}
            {convert.canTransfer ? 'Available' : 'Available'}
          </span>

          <div className='product-img'>
            <span className='ribbon ribbon-clip-bottom-right ribbon-primary'>
              <b>Spaceship Rarity:</b>{' '}
              <Rating
                initialRating={card.nftData.level}
                emptySymbol='fa fa-star-o'
                fullSymbol='fa fa-star'
                readonly={true}
              />{' '}
              <br />
            </span>

            {videoAnimation ? (
              <video
                className='img-fluid'
                muted
                loop={videoAnimation}
                autoPlay={videoAnimation}
                poster={`${ASSETS_CDN}/spaceships/rank${card.nftData.level}/${convert.variant}.png`}
              >
                <source src={`${ASSETS_CDN}/spaceships/rank${card.nftData.level}/${convert.variant}.mp4`} />
                <img className='img-fluid'
                  alt='Spaceship NFT'
                  src={`${ASSETS_CDN}/spaceships/rank${card.nftData.level}/${convert.variant}.png`}
                />
              </video>
            ) : (
              <img className='img-fluid'
                src={`${ASSETS_CDN}/spaceships/rank${card.nftData.level}/${convert.variant}.png`}
                alt='Cryptomines Spaceship'
              />
            )}
          </div>
          <div className='product-details'>
            <div className='product-price'>
              <center> {card.nftData.level} WORKERS </center>

              <hr />

              <center>
                {convert.sold === 0 ? (
                  <Button className='btn btn-primary' onClick={() => buySpaceship(card.marketId)}>
                    {parseFloat(parseFloat(convert.price).toFixed(3))} ETERNAL <i className='icon-shopping-cart'></i>
                  </Button>
                ) : (
                  <div className='btn disabled'>SOLD or UNLISTED</div>
                )}
              </center>

              {card.sellerAddress === userAddress && convert.sold === 0 ? (
                <Button
                  id={'unlist-btn' + convert.uid}
                  className='btn btn-info unlist-button'
                  onClick={() => unlistNFT(card.marketId)}
                >
                  <span>UNLIST</span>
                  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'>
                    <path
                      data-name='layer2'
                      d='M47 7a16 16 0 1 0 16 16A16 16 0 0 0 47 7zm8 18H39a2 2 0 0 1 0-4h16a2 2 0 0 1 0 4z'
                    ></path>
                    <circle data-name='layer2' cx='21' cy='55' r='4'></circle>
                    <circle data-name='layer2' cx='47' cy='55' r='4'></circle>
                    <path
                      data-name='layer1'
                      d='M47 43a20 20 0 0 1-20-20H16.8L12.9 6.5A2 2 0 0 0 11 5H3a2 2 0 0 0 0 4h6.4l9 38h33l1.6-4.9a20 20 0 0 1-6 .9z'
                    ></path>
                  </svg>
                  <Tooltip placement='top' isOpen={btnTooltip} target={'unlist-btn' + convert.uid} toggle={toggle}>
                    Unlist my NFT
                  </Tooltip>
                </Button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Card>
    </div>
  ) : (
    ''
  );
};

export default MarketplaceSpaceships;
